import { createContext, useCallback, useMemo } from 'react';
import { tierHasFeature } from '../util/featureConfig';

export const FeatureGateContext = createContext({ tier: 0, hasFeature: () => false });

export function FeatureGateProvider({ tier = 0, children }) {
    const hasFeature = useCallback(
        (feature) => tierHasFeature(tier, feature),
        [tier]
    );

    const value = useMemo(() => ({ tier, hasFeature }), [tier, hasFeature]);

    return (
        <FeatureGateContext.Provider value={value}>
            {children}
        </FeatureGateContext.Provider>
    );
}
